import React from 'react';
import * as _ from 'underscore';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import $ from "jquery";
import * as d3 from 'd3';
import styled, { css, keyframes } from 'styled-components';
import {colorLookup} from '../utils/colorHash';
import { getData } from '../utils/api';

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: calc(100vh - 150px);
  overflow-y: hidden;
  background: #132033;
  &::-webkit-scrollbar{
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
      background-color: white;
      -webkit-border-radius: 4px;
    }

  & ::selection{
    text-shadow: none !important;
    background: none !important;
    color: #ffffff;
  }
`
const Footer = styled.div`
  height: 35px;
  width: 100%;
  position: absolute;
  background: #122035;
  bottom: 0;
  z-index: 100;
  &>p{
    color: white;
    font-size: 12px;
    font-family: 'Roboto';
    margin-bottom: 0;
    position: relative;
    float: right;
    margin-top: 5px;
    margin-right: 5%;
  }
`
const Title = styled.p`
  font-size: 30px;
  font-family: 'Roboto';
  color: white;
  font-weight: 700;
  left: 50%;
  text-align: center;
  background: #132033e6;
  padding-bottom: 15px;
  width: 70%;
  letter-spacing: 1px;
  position: absolute;
  top: ${props => props.animate ?"10%":'0%'};
  opacity: ${props => props.animate ?1:0};
  transform: translateX(-50%);
  z-index: 1;
  transition: top 3000ms, opacity 4000ms;
`
const EMAnimation = keyframes`
  0% {
    border-left: 1px dashed #ffffff00;
    border-top: 1px dashed #ffffff00;
    border-right: 1px dashed #ffffff00;
  }
  100% {
    border-left: 1px dashed #ffffff8C;
    border-top: 1px dashed #ffffff8C;
    border-right: 1px dashed #ffffff8C;
  }
`
const EM = styled.em`
  line-height: 2.1;
  border-radius: 5px;
  font-style: normal;
  font-weight: 900;
  padding: 4px 5px 3px 5px;
  margin: 0px 10px 0 10px;
  color: white;
  cursor: pointer;

  transition: background-size .25s ease-in-out, background-position .25s ease-in-out;
  background-image: linear-gradient(120deg,#fff,#fff);
  background-repeat: no-repeat;
  background-size: 100% .07em;
  background-position: 0 93%;

  animation: ${EMAnimation} 1200ms;
  animation-direction: alternate;
  animation-iteration-count: infinite;


  &:hover{
    background-position: 0% 100%;
    background-image: linear-gradient(120deg,#E91E63,#f47d03);
    background-size: 100% 50%;
  }

  ${props => props.selected && css`
    background-position: 0% 100%;
    background-image: linear-gradient(120deg,#1676ef,#77e6b3);
    background-size: 100% 12%;
  `}
`
const Annotation = styled.div`
  position: absolute;
  left: 2%;
  bottom: 30px;
  height: 20px;
  z-index: 1;
`
const AnnotationItem = styled.p`
  position: relative;
  cursor: pointer;
  float: left;
  color: #122035;
  padding: 0px 10px 2px 10px;
  margin-right: 10px;
  border-radius: 5px;
  background: ${props => props.color};
  transition: all 400ms;
  &:hover{
    opacity: 0.8;
  }

${props => props.name === props.mvTag && css`
  &::before{
    content: ${() =>'"'+ 'Total: '+ props.data + ' / 1140'+'"'};
    position: absolute;
    bottom: 30px;
    background: ${props => props.color};
    padding: 10px 10px 13px 10px;
    color: #122035;
    border-radius: 3px;
    width: 200px;
    left: 0;
  }
  `}
`
const ChartContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`
const ButtonGroup = styled.div`
  position: absolute;
  bottom: ${props => props.animate ?"150px":'50px'};
  opacity: ${props => props.animate ?"1":'0'};
  right: 50%;
  transform: translate(50%,0%);
  width: 60%;
  transition: bottom 3000ms, opacity 4800ms;
  & > p{
    border: none;
    border-radius: 0;
    background: #1e3250cc;
    cursor: pointer;
    position: relative;
    font-size: 16px;
    letter-spacing: 1px;
    font-family: 'Roboto';
    font-weight: 300;
    color: white;
    text-align: center;
    transition: all 400ms;
    float: left;
    width: ${() => ((window.innerWidth*.6) /3 - 20*3) + 'px'}
    margin: 0 30px 0 30px;
    padding: 15px 0 15px 0;
  }
  & > p:hover{
    background: #b7b7ef69;
  }
`
// const annotationMargin = 80;
const clusterPaddingBottom = 0;
const sizeLookup = {
  'Between 10 and 249': [10,249],
  'Between 250 and 5K': [250, 4999],
  'Between 5K and 50K' : [5000,50000],
  'Greater than 50K': [50001,Infinity]
}
const color = colorLookup;


export default class OverviewContainer extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      data: null,
      totalParticipants: 0,
      totalRegionCount:0,
      currentChoice: 'totalParticipants',
      animate:false,
    }
    this.calculateChart = this.calculateChart.bind(this);
    this.calculatingForce = this.calculatingForce.bind(this);
    this.ticked = this.ticked.bind(this);
    this.onZoom = this.onZoom.bind(this);
    this.handleTitleClick = this.handleTitleClick.bind(this);
    this.calculateChoiceCoord = this.calculateChoiceCoord.bind(this);
    this.generateAnnotation = this.generateAnnotation.bind(this);
    this.tickCounter = 0;
  }

  calculateChart(){

    const width = $(this.chartContainer).width();
    const height = $(this.chartContainer).height();
    this.zoom = d3.zoom().scaleExtent([.5, 1]).on("zoom", this.onZoom);

    // svg, g
    const _svg = d3.select(this.chartContainer).append('svg').attr('width','100%').attr('height','100%').call(this.zoom);
    this.g = _svg.append('g')

    // force layout
    this.calculatingForce();
  }

  calculateChoiceCoord(value,width,height){

    const out = [];
    var step = 3;
    if(value === 'totalRegionCount'){step = 3}
    else if(value === 'companySize'){step = 9};

    const clusters = this.state[value].length;
    let margin = 50;
    if(value === 'companySize'){margin = -180}
    for (var i = 0; i < clusters; i++) {

      out[i] = {
        x: (width/clusters)*(i+1) + margin,
        y: ((height/2)) - clusterPaddingBottom + 70,
        color: color(i+step),
        _key: this.state[value][i],
      }
    }
    return out;
  }

  calculatingForce(){
    const width = $(this.chartContainer).width();
    const height = $(this.chartContainer).height();
    const node_radius = 5;
    this.choiceList = {
      "totalParticipants": { x: width/2, y: height/2 - clusterPaddingBottom + 70, color:'#699CC6'},
      "totalRegionCount": this.calculateChoiceCoord('totalRegionArr',width,height),
      "companySize": this.calculateChoiceCoord('companySize',width,height),
    };
    const vizData = this.state.data.map((d,i) => {
      return ({
        id: 'node_'+ i,
        Participant_ID: d.Participant_ID,
        x:Math.random(),
        y:Math.random(),
        radius: node_radius,
        // country: d.Q355_2,
        region: d.Region,
        companySize: d.Number_of_Employees,
      })
    });

    this.simulation = d3.forceSimulation()
      .nodes(vizData)
      .force("y", d3.forceY(d => this.choiceList[this.state.currentChoice].y) )
      .force("x", d3.forceX(d => this.choiceList[this.state.currentChoice].x) )
      .force("charge", d3.forceManyBody().strength(-8))
      .force("collide",d3.forceCollide(2).strength(.9).iterations(3));
    this.simulation.on("tick", this.ticked);

    this.node = this.g.selectAll('circle')
      .data(vizData)
      .enter()
      .append('circle')
      .style('fill',this.choiceList[this.state.currentChoice].color)
      .attr("r", d => d.radius)
      .attr("cx",d => d.x)
      .attr("cy",d => d.y);
  }

  ticked(){
    this.node.attr("cx", d => d.x).attr("cy", d => d.y);
  }

  onZoom(){
    this.g.attr("transform", d3.event.transform);
  }

  handleTitleClick(choice,pairValue){
    this.tickCounter = 0;
    this.setState({currentChoice:choice},() =>{

      if(this.state.currentChoice === 'companySize'){
        this.node.style('fill',d => {
          const find = _.find(this.choiceList[this.state.currentChoice],_d =>d[pairValue] >= sizeLookup[_d._key][0] && d[pairValue] <= sizeLookup[_d._key][1])
          if(find){
            return find.color;
          }
        });
      }
      else{
        this.node.style('fill',d => _.find(this.choiceList[this.state.currentChoice],_d => _d._key === d[pairValue])['color']);
      }


      if(this.state.currentChoice === 'totalParticipants') this.node.style('fill','#699CC6');

      if(this.state.currentChoice === 'companySize'){
        this.simulation
          .force("x", d3.forceX(d =>{
            const find = _.find(this.choiceList[this.state.currentChoice],_d => d[pairValue] >= sizeLookup[_d._key][0] && d[pairValue] <= sizeLookup[_d._key][1] );
            if(find) return find.x
          }
          ))
          .force("y", d3.forceY(d =>{
            const find = _.find(this.choiceList[this.state.currentChoice],_d => d[pairValue] >= sizeLookup[_d._key][0] && d[pairValue] <= sizeLookup[_d._key][1]);
            if(find) return find.y
          }
          ))
          .alphaTarget(0.3).restart()

        return;
      }

      // re-heat simulation
      this.simulation
        .force("x", d3.forceX(d => this.state.currentChoice === 'totalParticipants'
          ? this.choiceList[this.state.currentChoice].x
          : _.find(this.choiceList[this.state.currentChoice],_d => _d._key === d[pairValue])['x']
        ))
        .force("y", d3.forceY(d => this.state.currentChoice === 'totalParticipants'
          ? this.choiceList[this.state.currentChoice].y
          : _.find(this.choiceList[this.state.currentChoice],_d => _d._key === d[pairValue])['y']
        ))
        .alphaTarget(0.3).restart()

    });
  }

  generateAnnotation(choice){
    const a = this.choiceList[choice].map(d =>{
      return <AnnotationItem
        key={d._key}
        name={d._key}
        mvTag={this.state.mvTag}
        data={this.state.currentChoice === 'totalRegionCount' ? this.region_tooltipData[d._key].length : this.companySize_tooltipData[d._key].length}
        onMouseEnter={() =>this.setState({mvTag: d._key})}
        onMouseOut={() => this.setState({mvTag: null})}
        color={d.color}>{d._key === '' ? 'Null':d._key}</AnnotationItem>
    })
    return a
  }

  componentDidMount() {
    window.setTimeout(() => this.setState({animate:true}) ,1);

    this.setState({data: getData()},() => {

      const _totalRegionArr = (() =>{
        let temp = [];
        let companySize = [];
        this.state.data.forEach((d) => { temp.push(d.Region);companySize.push(d.Number_of_Employees); })
        this.region_tooltipData = _.groupBy(temp);
        this.companySize_tooltipData = _.groupBy(companySize.map(d => {
          var v = '';
          Object.keys(sizeLookup).forEach(_d =>{
            if(d >= sizeLookup[_d][0] && d <= sizeLookup[_d][1]) v = _d;
          })
          return v
        }));
        return _.uniq(temp);
      })();

      this.setState({
        totalParticipants: this.state.data.length,
        totalRegionCount: _totalRegionArr.length,
        totalRegionArr: _totalRegionArr,
        companySize: Object.keys(sizeLookup),
        mvTag: null
      },() => this.calculateChart() );
    });
  }

  componentWillUnmount() {
      window.removeEventListener('zoom', this.onZoom, false);
      this.simulation.stop();
  }

  render(){
    return(

        <div>
          <Wrapper>
            <Title animate={this.state.animate}>
              In 2018, we received
                 <EM
                  selected={this.state.currentChoice === 'totalParticipants'? true: false}
                  onClick={() => this.handleTitleClick('totalParticipants')}>{this.state.totalParticipants}</EM>
              respondents, from
                <EM
                  selected={this.state.currentChoice === 'totalRegionCount'? true: false}
                  onClick={() => this.handleTitleClick('totalRegionCount','region')}>{this.state.totalRegionCount} regions.</EM>
              Company size range from
              <EM
                selected={this.state.currentChoice === 'companySize'? true: false}
                onClick={() => this.handleTitleClick('companySize','companySize')}>10 employees to over 50,000.</EM>

            </Title>
            {this.state.currentChoice != 'totalParticipants' && <Annotation>{this.generateAnnotation(this.state.currentChoice)}</Annotation>}
            <ChartContainer innerRef={(chartContainer) => {return this.chartContainer = chartContainer }}/>

            <ButtonGroup animate={this.state.animate}>
              <p onClick={() =>{this.props.history.push('/tenprinciples')}}>Explore Ten Principles Section</p>
              <p onClick={() =>{this.props.history.push('/sdgs')}}>Explore SDGs Section</p>
              <p onClick={() =>{this.props.history.push('/impact')}}>Explore Impact Section</p>
            </ButtonGroup>
          </Wrapper>
          <Footer>
            <p>2018 United Nations Global Compact Progress Report</p>
          </Footer>
        </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/OverviewContainer.js